
import { accountLogin, getQwGcUrl, bindQw, toOrgProject } from '@/services/account'
import rules from './rules'
import { setAuth } from '@/lib/storage'
export default {
  namespaced: true,
  state: {
    submitting: false,
    decorators: {
      account: ['account', { rules: rules.account, initialValue: 'admin' }],
      mobile: ['mobile', { rules: rules.tel }],
      checkcode: ['checkcode', { rules: rules.validCode }],
      username: ['username', { rules: rules.account, initialValue: '' }],
      password: ['password', { rules: rules.password2, initialValue: '' }]
    }
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    }
  },
  actions: {
    async login ({ commit, actions, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await accountLogin()
      chain.params(data)
        .onSuccess(async payload => {
          console.log('登录成功')
          const { Authorization } = payload
          setAuth(Authorization)
          await commit('setAuth', Authorization, { root: true })
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({
          tip: false,
          error602 () {
            alert('xxxx')
          }
        })
      return chain
    },

    // 获取企业微信和工厂网登录地址
    async getQwGcUrl ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getQwGcUrl()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },
    // 企业微信绑定
    async QwDdBindAjax ({ commit }) {
      commit('setSubmitting', true)
      const chain = await bindQw()
        .onSuccess(res => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config('tip', false)
      return chain
    },
    // 跳转项目
    async toOrgProject ({ commit, state }, data) {
      const chain = await toOrgProject()
      chain.params(data)
        .onSuccess(raw => {

        })
        .fetch()
      return chain
    }
  }
}
